/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { BridgeService } from '../bridge/bridge.service';
import { NetworkStatusService } from '../network-status-service/network-status.service';
import { StatusCodeZeroAnalyzerConfig } from './analyze-status-code-zero';
import { StatusCodeZeroAnalyzer } from './status-code-zero-analyzer';

@Injectable({
    providedIn: 'root'
})
export class StatusCodeZeroAnalyzerFactoryService {
    constructor(
        private networkStatusService: NetworkStatusService,
        private bridgeService: BridgeService
    ) {}

    createAnalyzer(params: StatusCodeZeroAnalyzerConfig) {
        const analyzer = new StatusCodeZeroAnalyzer(params, this.networkStatusService, this.bridgeService);
        return analyzer;
    }
}
